export default "__VITE_ASSET__18b7367a__"